import {useRoutePayload} from '@github-ui/react-core/use-route-payload'
import {Box, Heading, Link, Pagehead, PageLayout} from '@primer/react'

import {AttestationsTable} from '../components/AttestationsTable'
import type {AttestationsPayload} from '../types'

export const AttestationsIndex = () => {
  const payload = useRoutePayload<AttestationsPayload>()
  return (
    <PageLayout rowGap="none">
      <PageLayout.Header>
        <Pagehead sx={{pb: 2, pt: 0, mb: 3}}>
          <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2}}>
            <Box sx={{display: 'flex', alignItems: 'center'}}>
              <Heading as="h2" sx={{fontWeight: 'normal', fontSize: 4, lineHeight: 1}}>
                Attestations
              </Heading>
            </Box>
            {payload.feedbackUrl?.length > 0 && (
              <div>
                <Link href={payload.feedbackUrl} target="_blank" sx={{fontSize: '12px'}}>
                  Give feedback
                </Link>
              </div>
            )}
          </Box>
        </Pagehead>
      </PageLayout.Header>
      <PageLayout.Content>
        <AttestationsTable repo={payload.repo} attestations={payload.attestations} pageInfo={payload.pageInfo} />
      </PageLayout.Content>
    </PageLayout>
  )
}

try{ AttestationsIndex.displayName ||= 'AttestationsIndex' } catch {}